<app-edtell-front-facing-dialog [config]="frontFacingDialogConfig" *ngIf="loaded">
    <div class="row">
        <div class="col-12 d-flex">
            <app-srs-radio-button [config]="radioConfig"></app-srs-radio-button>
            <div class="radio-label ml-4 d-flex align-items-center">
                <span class="label-bold">I am a prospective NCAA Division I or II student-athlete.</span>
            </div>
        </div>
    </div>

    <div class="row mb-4" *ngIf="this.showNcaaId">
        <div class="col-12">
            <app-srs-form-field [config]="formFieldConfig"></app-srs-form-field>
        </div>
    </div>

    <div class="row mb-4">
        <div class="col-12">
            <app-edtell-front-facing-card>
                <p>
                    - Educere can help answer questions regarding NCAA Eligibility.<br>
                    866-4EDUCERE (866-433-8237)<br>
                    - You can visit the NCAA Student Athlete Eligibility Center to apply for your NCAA ID.<br>
                    <a href="https://web3.ncaa.org/ecwr3/" target="_blank">NCAA Eligibility Center</a>
                </p>
            </app-edtell-front-facing-card>
        </div>
    </div>
</app-edtell-front-facing-dialog>